import { ref } from "vue";
import { useStore } from "@/store";
const store = useStore();
import { GeneralActionTypes } from "@/store/modules/general/action-types";

const data = {
  readyToUseFilters: {},
  filter: {
    searchResult: true,
    searchText: true,
    customize: {
      id: "customizeModal",
      action: {
        label: "Save",
        function: function (arg: any) {
          alert(JSON.stringify(arg));
        },
      },
      cancel: {
        label: "Close",
      },
      items: [
        {
          title: "eventfilterconfiguration",
          component: "Customize",
          options: {
            elements: [
              {
                label: "password",
                field: "input",
                type: "text",
                name: "password",
                class: "col-md-6",
                required: true,
                value: null,
              },
            ],
          },
        },
      ],
    },
    title: "newhashfilter",
    pageName: "HashPageFilter",
    genre: "hashPageFilter",
    filters: [
      {
        title: "companySiteGroup",
        type: "siteAndGroup",
        selectType: "multiple",
        selectedLabel: null,
        vmodel: "",
        param: "groupGuid",
        apiEquivalent: "groupGuid",
        data: [],
      },
      {
        title: "Computer",
        type: "computer",
        vmodel: "",
        param: "computerGuid",
        apiEquivalent: "computerGuid",
        data: [],
      },
      {
        title: "Hash",
        type: "wordstyped",
        param: "hash",
        apiEquivalent: "hash",
      },
      {
        title: "Hash Type",
        type: "select",
        param: "hashtype",
        vmodel: "",
        apiEquivalent: "hashtype",
        placeholder: "Select hash type",
        data: [
          {
            id: "Malicious",
            hashtype: "Malicious",
          },
          {
            id: "Suspicious",
            hashtype: "Suspicious",
          },
          {
            id: "Harmless",
            hashtype: "Harmless",
          },
          {
            id: "Notfound",
            hashtype: "Not Found",
          },
        ],
      },
      // {
      //   title: "File",
      //   type: "wordstyped",
      //   param: "file",
      // },
      {
        title: "Time Range",
        type: "date",
        param: "range",
        apiEquivalent: "range",
        hidden: true,
        vmodel: null,
      },
    ],
    savedFilter: {
      columns: [
        {
          label: "savedhashfilter",
          field: "title",
          sortable: false,
        },
        {
          label: "",
          sortable: false,
          components: [
            {
              component: "tableLoadComponent",
              emit: "hashInspectionLoad",
            },
          ],
        },
      ],
      rows: [],
      total: 5,
      sortable: {
        order: "filtername",
        sort: "asc",
      },
      page: 1,
      pageSize: 5,
      isLoading: false,
    },
  },
  header: {
    navigation: [
      {
        title: "malicious",
        url: "malicious",
      },
      {
        title: "suspicious",
        url: "suspicious",
      },
      {
        title: "harmless",
        url: "harmless",
      },
      {
        title: "notfound",
        url: "notfound",
      },  
      {
        title: "allhashes",
        url: "allhashes",
      },
    ],
    // buttonPosition: "justify-content-between",
    // buttons: [
    //   {
    //     title: "export",
    //     icon: "export",
    //     class: "secondary mr-3",
    //     link: "#",
    //     target: "",
    //     toggle: "",
    //   },
    // ],
  },
  component: {
    type: "ag-table",
    options: {
      id: "exportable-table",
      export: {
        fileName: "hash_inspection",
      },
      dateFilter: true,
      columns: [
        {
          label: "hash",
          width: '15%',
          sortable: false,
          excelField: "hash",
          components: [
            {
              component: "tableModalComponent",
              field: "hash",
              copyPaste: true,
              truncate: {
                position: "middle",
                first: 6,
                last: 12,
              },
            },
          ],
        },
        {
          label: "path",
          field: "path",
          width: '10%',
          sortable: false,
          components: [
            {
              component: "ThreatPath",
            },
          ],
        },
        {
          label: "hashtype",
          field: "hashType",
          excelField: "hashType",
          sortable: false,
        },
        {
          label: "count",
          field: "docCount",
          format: "number",
          excelField: "docCount",
          sortable: true,
        },
        {
          label: "endpointcount",
          field: "computerCount",
          format: "number",
          excelField: "computerCount",
          sortable: true,
        },
        {
          label: "firstseen",
          sortable: true,
          excelField: "firstSeen",
          field: "firstSeen",
          components: [
            {
              component: "tableDateFormatter",
              field: "firstSeen",
            },
          ],
        },
        {
          label: "lastseen",
          sortable: true,
          excelField: "lastSeen",
          field: "lastSeen",
          components: [
            {
              component: "tableDateFormatter",
              field: "lastSeen",
            },
          ],
        },
        {
          label: "",
          // field: "edit",
          width: '100px',
          components: [
            {
              component: "tableExpandComponent",
              filter: () => {
                return data.readyToUseFilters;
              },
            },
          ],
        },
      ],
      rows: [],
      sortable: {
        order: "",
        sort: "asc", 
      },
      total: 0,
      page: 1,
      pageSize: 5,
      loadType: "page",
      isLoading: true,
      fetchTable: async (options: any) => {
        const filters = data.readyToUseFilters; //data.filter
        const body = { filters, options };
        store.dispatch(GeneralActionTypes.GET_HASHES, body);
      },
    },
  },
  modals: [
    {
      id: "exampleModalCenter",
      action: {
        label: "Save",
        function: function (arg: any) {
          alert(JSON.stringify(arg));
        },
      },
      cancel: {
        label: "Close",
      },
      items: [
        {
          title: "hashdetails",
          component: "ag-hashdetail",
        },
        {
          title: "whereFound",
          component: "ag-hashvisibility",
        },
      ],
    },
  ],
};

export default data;
